import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  id: string;
}

const mutateDeleteDependency = async ({
  projectId,
  taskId,
  id,
}: mutateProps) => {
  return await axiosAuth.delete(`${PROJECT_API}/${projectId}/tasks/${taskId}/dependencies/${id}`);
};

const useDeleteDependencyMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteDependency,
    ...queryParams,
  });

export default useDeleteDependencyMutation;
